var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_holidayType_list_title"),
      addBtn: _vm.hasBtn("add-admin-public-holiday-type"),
      backgroundClass: "transparent",
      pad: "0",
    },
    on: { new: _vm.toNew },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                height: _vm.$vuetify.breakpoint.height - 275,
                "filter-page-data": _vm.filterPageData,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.holiday_type_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(_vm.$getCommonLangValue(item.holiday_type_name))
                      ),
                    ]
                  },
                },
                {
                  key: "item.holiday_type_code",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(_vm._s(item.holiday_type_code))]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn(
                            "delete-admin-public-holiday-type"
                          ),
                          editBtn: _vm.hasBtn("edit-admin-public-holiday-type"),
                          viewBtn: _vm.hasBtn("view-admin-public-holiday-type"),
                          title: _vm.$t("label_essweb_holidayType_list_title"),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toView,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }